import { takeEvery, takeLeading, delay, call, put } from 'redux-saga/effects';
import { SHOW_TOAST } from 'constants/actionTypes';
import * as toastActions from 'actions/toaster';
import Toaster from 'components/Common/Toaster';
import { patterns as rulePatterns } from 'actions/account/rules';
import { patterns as flowPatterns } from 'actions/account/flows';
import { patterns as chartPatterns } from 'actions/account/charts';
import { patterns as segmentPatterns } from 'actions/account/segments';
import { patterns as goalPatterns } from 'actions/account/goals';
import {
  USER_REMOVED,
  USER_ROLE_UPDATE_FAILED,
  USER_ROLE_UPDATE_SUCCEEDED,
} from 'constants/account/users';
import { patterns as profileAttributeLabelPatterns } from 'entities/profile-attribute-labels';

export function* showToast({ payload: { toastProps } }) {
  yield call([Toaster, Toaster.show], toastProps);
}

export function* showDelayedToast(toastProps, delayMs) {
  yield delay(delayMs);
  yield put(toastActions.showToast(toastProps));
}

export function* showFlushToast() {
  yield call(
    showToast,
    toastActions.showToast({ message: 'Changes saved', type: 'success' })
  );
}

export function* showUserRemovedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'User removed successfully',
      type: 'success',
    })
  );
}

export function* showUserRoleUpdatedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Role updated',
      type: 'success',
    })
  );
}

export function* showUserRoleUpdateFailedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Role update failed, please try again.',
      type: 'error',
    })
  );
}

export function* showChartCreatedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Chart created',
      type: 'success',
    })
  );
}

export function* showChartSavedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Chart saved',
      type: 'success',
    })
  );
}

export function* showChartRemovedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Chart deleted',
      type: 'success',
    })
  );
}

export function* showSegmentCreatedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Segment created successfully',
      type: 'success',
    })
  );
}

export function* showSegmentUpdatedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Segment updated successfully',
      type: 'success',
    })
  );
}

export function* showSegmentDeletedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Segment deleted successfully',
      type: 'success',
    })
  );
}

export function* showGoalCreatedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Goal created successfully',
      type: 'success',
    })
  );
}

export function* showGoalUpdatedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Goal updated successfully',
      type: 'success',
    })
  );
}

export function* showGoalDeletedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Goal deleted successfully',
      type: 'success',
    })
  );
}

export function* showProfileAttributeUpdatedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: 'Profile attribute updated successfully',
      type: 'success',
    })
  );
}

/*
  @todo suggested refactor to prevent this file from getting full of similar sagas
  w/ different static values -- add `notificationText`, `notificationType` props
  to a `meta` prop of the action, have the saga use those values
 */
function* toaster() {
  yield takeEvery(SHOW_TOAST, showToast);
  yield takeLeading([rulePatterns.flush, flowPatterns.flush], showFlushToast);
  yield takeLeading(USER_REMOVED, showUserRemovedToast);
  yield takeLeading(USER_ROLE_UPDATE_SUCCEEDED, showUserRoleUpdatedToast);
  yield takeLeading(USER_ROLE_UPDATE_FAILED, showUserRoleUpdateFailedToast);
  yield takeLeading(chartPatterns.insert, showChartCreatedToast);
  yield takeLeading(chartPatterns.flush, showChartSavedToast);
  yield takeLeading(chartPatterns.remove, showChartRemovedToast);
  yield takeLeading(segmentPatterns.insert, showSegmentCreatedToast);
  yield takeLeading(segmentPatterns.replace, showSegmentUpdatedToast);
  yield takeLeading(segmentPatterns.remove, showSegmentDeletedToast);
  yield takeLeading(goalPatterns.insert, showGoalCreatedToast);
  yield takeLeading(goalPatterns.replace, showGoalUpdatedToast);
  yield takeLeading(goalPatterns.remove, showGoalDeletedToast);
  yield takeLeading(
    profileAttributeLabelPatterns.insert,
    showProfileAttributeUpdatedToast
  );
}

export default toaster;
